import React from 'react'

/**
 * Ícones de traço fino para serviços que não têm fotografia própria.
 *
 * Um serviço escolhe o seu ícone pelo campo `icon` do catálogo
 * (`src/data/services.js`). Sem foto e sem ícone, usa-se o brilho.
 */
const ICONES = {
  // tesoura — cortes, franja, barba
  tesoura: (
    <>
      <circle cx="6" cy="6" r="3" />
      <circle cx="6" cy="18" r="3" />
      <path d="M20 4 8.12 15.88" />
      <path d="M14.47 14.48 20 20" />
      <path d="M8.12 8.12 12 12" />
    </>
  ),
  // brilho — tratamentos (botox capilar)
  brilho: (
    <>
      <path d="M9.94 15.5A2 2 0 0 0 8.5 14.06l-6.14-1.58a.5.5 0 0 1 0-.96L8.5 9.94A2 2 0 0 0 9.94 8.5l1.58-6.14a.5.5 0 0 1 .96 0l1.58 6.14a2 2 0 0 0 1.44 1.44l6.14 1.58a.5.5 0 0 1 0 .96l-6.14 1.58a2 2 0 0 0-1.44 1.44l-1.58 6.14a.5.5 0 0 1-.96 0z" />
      <path d="M20 3v4M22 5h-4M4 17v2M5 18H3" />
    </>
  ),
  // feixe — depilação a laser
  laser: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
    </>
  ),
  // gota de cera — epilação a cera
  cera: (
    <>
      <path d="M12 3c-2.5 3.4-5 6.4-5 9.5a5 5 0 0 0 10 0C17 9.4 14.5 6.4 12 3z" />
      <path d="M9.5 13a2.5 2.5 0 0 0 2.5 2.5" />
    </>
  ),
  // gota — shampoo
  gota: <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z" />,
  // bolhas — espumas
  espuma: (
    <>
      <circle cx="8.5" cy="14.5" r="4.5" />
      <circle cx="16" cy="8" r="3" />
      <circle cx="17.5" cy="17" r="2" />
      <path d="M6.5 13a2 2 0 0 1 2-2" />
    </>
  ),
  // frasco — máscaras
  mascara: (
    <>
      <path d="M6 5.5h12a1 1 0 0 1 1 1V9H5V6.5a1 1 0 0 1 1-1z" />
      <path d="M6 9h12v9a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3z" />
      <path d="M9.5 14h5" />
    </>
  ),
}

export const ServiceIcon = ({ name, className = 'h-6 w-6' }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {ICONES[name] || ICONES.brilho}
  </svg>
)

/**
 * Painel que ocupa o lugar da fotografia: degradê da paleta do site com o
 * ícone num medalhão. Mantém a proporção dos cartões com foto (4:5) para a
 * grelha não ficar desalinhada.
 */
export const IconPanel = ({ name, className = '' }) => (
  <div
    className={`relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#f3f3eb] via-[#F5F1E9] to-[#a5bf99]/30 ${className}`}
    aria-hidden="true"
  >
    {/* círculos decorativos, muito ténues */}
    <span className="absolute -top-10 -right-10 w-40 h-40 rounded-full border border-[#c0a080]/20" />
    <span className="absolute -bottom-14 -left-12 w-48 h-48 rounded-full border border-[#a5bf99]/30" />

    <span className="relative flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-white/70 border border-[#c0a080]/30 shadow-sm text-[#5c7160] transition-transform duration-500 group-hover:scale-105">
      <ServiceIcon name={name} className="h-9 w-9 sm:h-10 sm:w-10" />
    </span>
  </div>
)

export default ServiceIcon
